@if (leadDetail$ | async; as leadDetail) {
  <div
    class="tab-pane fade flex-even active show h-100"
    id="calls"
    role="tabpanel"
    aria-labelledby="calls-tab"
  >
    <div class="d-flex flex-column h-100">
      <div class="row mt-2">
        <div class="col-12 col-md">
          <app-generic-grid
            style="height: 300px"
            [data]="leadDetail.calls"
            [tabViewName]="'calls'"/>
        </div>
      </div>
    </div>
  </div>
}
